import { Observable, observe, Scope } from 'src/3rds/cube'

// :: Types (espelham apps/server/src/templates/templates.types.ts)

export type Template = {
    id: string
    nome: string
    idioma: string
    status: string
    categoria: string
    categoriaAnterior?: string
    qualidade?: string
    motivoRecusa?: string
    corpo: string
    variaveis: string[]
    botoes: string[]
    formato: 'NAMED' | 'POSITIONAL'
    simulado?: boolean
    usos: string[]
    /** Campanhas de notícias que mandam este template a quem está fora da janela. */
    campanhas?: string[]
    /** Formato do cabeçalho: IMAGE nos templates de campanha. */
    cabecalho?: string
    /** Quando a cópia local deste template foi lida da Meta. */
    lidoEm?: string
}

export type SituacaoUso = 'ok' | 'padrao' | 'sem_template' | 'nao_encontrado' | 'nao_aprovado' | 'incompativel'

export type Uso = {
    uso: string
    descricao: string
    variaveis: string[]
    botoes: string[]
    template?: string
    idioma?: string
    padrao: boolean
    atualizadoPor?: string
    atualizadoEm?: string
    situacao: SituacaoUso
    problemas: string[]
    categoria?: string
    nomeSugerido?: string
    texto?: string
    /** De onde vem o texto que o parceiro lê: do template ligado ou, quando ele não serve, do código. */
    fonteDoTexto?: 'template' | 'codigo'
}

export type Editor = {
    modo: 'criar' | 'editar'
    /** Na edição, o id do template na Meta. */
    templateId?: string
    nome: string
    categoria: 'UTILITY' | 'MARKETING'
    idioma: string
    corpo: string
    exemplos: Record<string, string>
    botoes: string[]
    /** Uso para o qual o template está sendo criado (o texto veio dele). */
    paraUso?: string
}

// :: Scopes

@Observable
export class TemplatesScope extends Scope {
    @observe() carregando = false
    @observe() usos: Uso[] = []
    @observe() templates: Template[] = []
    @observe() busca = ''
    /** Os templates de exemplo que a Meta cria em toda conta (sample_*, hello_world). */
    @observe() mostrarExemplosMeta = false

    @observe() detalhe?: Template

    @observe() editor?: Editor
    @observe() erroEditor?: string
    @observe() salvando = false

    /** Uso cujo template está sendo trocado. */
    @observe() trocar?: Uso
    @observe() erroTrocar?: string

    /** Template sem uso cuja exclusão está sendo confirmada. */
    @observe() excluir?: Template
    @observe() erroExcluir?: string

    onAtualizar = Scope.ASYNC_ACTION
    onBuscaChange = Scope.SYNC_ACTION_STRING
    onMostrarExemplosChange = Scope.SYNC_ACTION_ONE<boolean>()

    onAbrirDetalhe = Scope.SYNC_ACTION_STRING
    onFecharDetalhe = Scope.SYNC_ACTION

    /** Vazio: template novo em branco; com o nome de um uso: já com o texto e o nome sugerido dele. */
    onAbrirCriar = Scope.SYNC_ACTION_STRING
    onAbrirEditar = Scope.SYNC_ACTION_STRING
    onEditorChange = Scope.SYNC_ACTION_ONE<Partial<Editor>>()
    onFecharEditor = Scope.SYNC_ACTION
    onSalvarEditor = Scope.ASYNC_ACTION

    onAbrirExcluir = Scope.SYNC_ACTION_STRING
    onFecharExcluir = Scope.SYNC_ACTION
    onExcluir = Scope.ASYNC_ACTION

    onAbrirTrocar = Scope.SYNC_ACTION_STRING
    onFecharTrocar = Scope.SYNC_ACTION
    /** "nome|idioma" do template escolhido. */
    onLigar = Scope.ASYNC_ACTION_STRING
}
